<template lang="pug">
div {{hello}}
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";

const hello = ref('Hello world')

onMounted(() => {
  // console.log(hello)
  hello.value = 'Hello world 2'
})
</script>

<style scoped>

</style>
